/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { AuthState } from '@ecsper/auth';
import type { SessionInfo } from '@ecsper/speciality-contract';

/** Maps an authenticated auth snapshot to {@link SessionInfo} for the task pane contract. */
export function mapAuthStateToSession(state: AuthState): SessionInfo | null {
  if (
    state.status !== 'authenticated' ||
    state.actor === null ||
    state.tenancy === null ||
    state.engagement === null
  ) {
    return null;
  }

  return {
    actorId: state.actor.user_id,
    organisationId: state.tenancy.organisation_id,
    officeId: state.tenancy.office_id,
    displayName: state.actor.display_name,
    entitlements: [...state.engagement.entitlements],
  };
}
